import { httpClient } from '@texas/api/httpClient/httpClient';

export interface FreightCostItem {
  id: number;
  name: string;
  value: number;
  organizationId: number;
  displayOrder: number;
  archived: boolean;
}

export interface CreateFreightCostRequest {
  name: string;
  value: number;
  displayOrder: number;
}

export interface UpdateFreightCostRequest extends CreateFreightCostRequest {
  archived: boolean;
}

export const freightCostsApi = {
  getAll: () => httpClient.get<FreightCostItem[]>('freightcosts/all'),
  createFreightCost: (
    organizationId: number,
    request: CreateFreightCostRequest,
  ) =>
    httpClient.post<FreightCostItem>(
      `organizations/${organizationId}/freightcosts`,
      {
        data: request,
      },
    ),
  update: (id: number, request: UpdateFreightCostRequest) =>
    httpClient.put<FreightCostItem>(`freightcosts/${id}`, { data: request }),
};
